<template>
  <div class="policy-alert-main">
    <div class="left-container">
      <Menus ref="menu" :menu="menus" @menuClicked="menuClicked" style="{ display: showMenu ? '' : 'none' }" />
    </div>
    <div class="right-container">
      <div class="top-right-container">
        <button class="refresh-button" @click="refreshClicked">Refresh</button>
        <div class="last-refreshed">Last Refreshed : {{ lastRefreshed }} </div>
      </div>
      <div class="bottom-right-container">
        <div class="tablebox">
          <TableBox title="Policy Alert" :selectedRow.sync="selectedRow" :tableData.sync="policyAlertListData"
            :dataType="policyAlertDataType" :hideColumns="['UserID', 'DateUpdated', 'UserCreated', 'TimeCreated']"></TableBox>
        </div>
      </div>
    </div>
    <PopupEntry v-if="showPopup" :show.sync="showPopup" :title="popupTitle" @save="saveClicked" :requiredError="requiredError" :errorMessages="errorMessages"
      @cancelClicked="cancelClicked" :viewMode="viewMode" :successMessages="popupEntrySuccessMsg" @requiredClicked="requiredClicked" :createdBy="createdBy" :updatedBy="updatedBy">
      <div class="popup-content">
        <div class="popup-content-top">
          <div class="popup-content-top-left">
            <Input class="id-no" placeholder="ID #" :isDisabled="true" :inputValue.sync="selectedIdNo" />
            <Input class="subject" placeholder="Subject" :isRequired="true" :inputValue.sync="selectedSubject"
              :errorMessage.sync="subjectError" :isDisabled="viewMode" ref="subject"/>
            <Dropdown class="alert-dropdown" placeholder="Alert Type" :isRequired="true" :items="alertTypeData"
              itemKey="Description" :selectedObject.sync="selectedAlertType" :errorMessage.sync="alertTypeError" :isDisabled="viewMode" ref="alertType"/>
            <div class="duration">
              <Input class="duration-input" placeholder="Duration" :isRequired="true" :inputValue.sync="selectedDuration"
                :errorMessage.sync="durationError" validator="positiveInteger,4" :isDisabled="viewMode" ref="duration"/>
              <Dropdown class="duration-dropdown" placeholder="Duration Type" :isRequired="true" :items="durationTypeData"
                itemKey="Description" :errorMessage.sync="durationTypeError" :selectedObject.sync="selectedDurationType" 
                :isDisabled="viewMode" ref="durationType"/>
            </div>
            <InputQuery class="input-query" placeholder="Policy Type" :isRequired="true" :items="policyTypeData"
              itemKey="PolicyType" descKey="Type" :errorMessage.sync="policyTypeError"
              :selectedObject.sync="selectedPolicyType" :isDisabled="viewMode" ref="policyType"/>
            <InputQuery class="input-query" placeholder="Category Code" :items="categoryCodeData" 
              itemKey="Category Code" :selectedObject.sync="selectedCategoryCode" descKey="Description" :isDisabled="viewMode" ref="categoryCode"/>
            <InputQuery class="input-query" placeholder="Vehicle #" :items="inventoryData"
              itemKey="Lorry No" descKey="Vehicle Code" :selectedObject.sync="selectedInventoryNo" :isDisabled="viewMode" ref="inventoryNo"/>
            <Input class="input-query" placeholder="Remarks" :inputValue.sync="selectedRemarks" validator="text,200" :isDisabled="viewMode"/>
          </div>
          <div class="popup-content-top-right">
              <EmailInput :mails.sync="selectedEmailRecipients" title="Email Recipient" style="margin-bottom:5px;" :isDisabled="viewMode">
                <button @click="emailRecipientListDataClicked" :disabled="viewMode">Add Email Recipient</button>
              </EmailInput>
            <EmailInput :mails.sync="selectedEmailCc" title="Cc To" style="margin-bottom:5px;" :isDisabled="viewMode">
              <button @click="emailCcListDataClicked" :disabled="viewMode">Add Email Cc To</button>
            </EmailInput>
            <EmailInput :mails.sync="selectedEmailBcc" title="Bcc To" :isDisabled="viewMode">
              <button @click="emailBccListDataClicked" :disabled="viewMode">Add Email Bcc To</button>
            </EmailInput>
          </div>
        </div>
      </div>
      <div v-if="showRecipientEmailList || showCcEmailList || showBccEmailList" class="emails-popup-container">
        <div class="emails-popup">
          <TableBox class="emails-table-box" :tableData="emailListData"
            :selectedRow.sync="selectedEmailRow" :title="getTitle" :maxSelection="-1" :columnWidth="[50,400]"/>
          <div class="call-to-action-buttons">
            <button @click="emailsPopupAddButtonClicked"> Add </button>
            <button @click="emailsPopupCancelButtonClicked"> Cancel </button>
          </div>
        </div>
      </div>
    </PopupEntry>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {

  },
  computed: {
    getTitle: function() {
      if (this.showRecipientEmailList) return "Add Recipients Emails";
      if (this.showCcEmailList) return "Add Cc Emails";
      if (this.showBccEmailList) return "Add Bcc Emails";
    }
  },
  data: function () {
    return {
      //popup
      popupTitle: '',
      createdBy: '',
      updatedBy: '',
      // Data list from Controller
      policyAlertListData: [],
      alertTypeData: [],
      durationTypeData: [],
      policyTypeData: [],
      categoryCodeData: [],
      inventoryData: [],
      emailListData: [],

      // TableBox Data Type
      policyAlertDataType: {
        "Duration": "number",
        "Vehicle #": "string",
      },

      // Currently selected or input Data 
      selectedRow: [],
      selectedEmailRow: [],
      selectedIdNo: '**/****/******',
      selectedSubject: '',
      selectedDuration: '',
      selectedAlertType: null,
      selectedDurationType: null,
      selectedPolicyType: null,
      selectedCategoryCode: null,
      selectedInventoryNo: null,
      selectedEmailRecipients: [],
      selectedEmailCc: [],
      selectedEmailBcc: [],
      selectedRecipients: [],
      selectedCc: [],
      selectedBcc: [],
      selectedRemarks: '',
      selectedAction: '',
      requiredError: [],
      errorMessages: [],

      // Error Messages
      subjectError: '',
      durationError: '',
      alertTypeError: '',
      durationTypeError: '',
      policyTypeError: '',

      // Last Refreshed
      lastRefreshed: null,
      // Show Pop Up Entry
      showPopup: false,
      viewMode: false,
      showRecipientEmailList: false,
      showCcEmailList: false,
      showBccEmailList: false,
      popupEntrySuccessMsg: [],

      // SAS Access Control
      showMenu: false,

      // Menu 
      menus: [
        { title: 'New Policy Alert', icon: 'https://dsmlib.logistics.systems/Icons/icons8-add-new-50.png', key: 'MnuNew', visible: true, enabled: true  },
        { title: 'Edit Policy Alert', icon: 'https://dsmlib.logistics.systems/Icons/icons8-edit-64%20(1).png', key: 'MnuEdit', visible: true, enabled: true },
        { title: 'Delete Policy Alert', icon: 'https://dsmlib.logistics.systems/Icons/icons8-reduce-50.png', key: 'MnuDelete', visible: true, enabled: true },
        { title: 'View Policy Alert', icon: 'https://dsmlib.logistics.systems/Icons/icons8-view-64.png', key: 'MnuQuery', visible: true, enabled: true },
      ],
    }
  },
  props: {

  },
  methods: {
    // Check input 
    checkErrors: function () {
      let errorCheck = false;
      if (this.selectedSubject === null || this.selectedSubject === '' || this.selectedSubject.trim() === '') {
        this.subjectError = "Subject is required!";
        this.requiredError.push({key: 'subject', value: this.subjectError});
        errorCheck = true;
      }
      if (this.selectedAlertType == null || Object.keys(this.selectedAlertType).length === 0) {
        this.alertTypeError = "Alert Type is required!";
        this.requiredError.push({key: 'alertType', value: this.alertTypeError});
        errorCheck = true;
      }
      if (this.selectedDurationType == null || Object.keys(this.selectedDurationType).length === 0) {
        this.durationTypeError = "Duration Type is required!";
        this.requiredError.push({key: 'durationType', value: this.durationTypeError});
        errorCheck = true;
      }
      if (this.selectedDuration === null || this.selectedDuration === '') {
        this.durationError = "Duration is required!";
        this.requiredError.push({key: 'duration', value: this.durationError});
        errorCheck = true;
      }
      if (this.selectedPolicyType === null || Object.keys(this.selectedPolicyType).length === 0) {
        this.policyTypeError = "Policy Type is required!";
        this.requiredError.push({key: 'policyType', value: this.policyTypeError});
        errorCheck = true;
      }
      if (this.selectedEmailRecipients === null || this.selectedEmailRecipients.length == 0) {
        this.errorMessages.push('At least one Email Recipient is required!');
        errorCheck = true;
      }

      return errorCheck;
    },
    // Clear Error Messages 
    clearErrorMessage: function () {
      this.subjectError = '';
      this.durationError = '';
      this.alertTypeError = '';
      this.durationTypeError = '';
      this.policyTypeError = '';
      this.popupEntrySuccessMsg = [];
      this.requiredError = [];
      this.errorMessages = [];
    },
    // Cancel button clicked
    cancelClicked: function () {
      this.clearPopUpEntry();
      this.clearErrorMessage();
    },
    // Save button clicked
    saveClicked: async function () {
      this.clearErrorMessage();
      // Check email filters (True = duplicated emails / False = No duplicate)
      if (this.checkErrors()) {
        this.$showAlert('error', 'Invalid Input', `Please fill in all required inputs`);
      } 
      else if (this.checkFilter()) {
        this.$showAlert('error', 'Duplicated Email Recipients', `An Email Recipient can only be selected once in all 3 of the email inputs`);
      }
      else {
        // Concatenate the email recipients into a single string with ";" as delimiter
        this.$fullscreenLoading("Saving Policy Alert");
        var emailRecipients = this.selectedEmailRecipients.map(email => email.email);
        var recipients = emailRecipients.join(";");
        var cc = this.selectedEmailCc.map(email => email.email).join(";");
        var bcc = this.selectedEmailBcc.map(email => email.email).join(";");

        this.selectedIdNo = (this.selectedAction == "N") ? "" : this.selectedIdNo; 

        let result = await this.$apiCallV2('/PolicyAlerts/SaveInventoryPolicyAlert', {
          Action: this.selectedAction,
          Id: this.selectedIdNo,
          Subject: this.selectedSubject,
          AlertType: this.selectedAlertType["Alert Type"],
          Duration: this.selectedDuration,
          DurationType: this.selectedDurationType["Duration Type"],
          Remarks: this.selectedRemarks,
          PolicyType: this.selectedPolicyType["Type"],
          InventoryNo: this.selectedInventoryNo ? this.selectedInventoryNo["Lorry No"] : "",
          CategoryCode: this.selectedCategoryCode ? this.selectedCategoryCode["Category Code"] : "",
          Recipient: recipients,
          Cc: cc,
          Bcc: bcc,
        });

        // API Call successfully
        if (result[0]['Results'] == 0) {
          if (this.selectedAction == 'N' || this.selectedAction == 'E') {
            this.popupEntrySuccessMsg.push(result[0]['ErrMsg']);
          }
        }
        // API Call failed
        else {
          if (this.selectedAction == 'N') {
            this.$showAlert('error', 'Policy Alert NOT Added',
              `There was an error Adding New Policy Alert`);
          }
          else {
            this.$showAlert('error', 'Policy Alert NOT Edited',
              `There was an error Editing Policy Alert ${this.selectedIdNo}`);
          }
        }

        // this.$fullscreenLoading("Saving Policy Alert");
        this.showPopup = true;
        this.viewMode = true;
        this.popupTitle = "View Policy Alert";
        this.selectedIdNo = result[0]['Id'];
        this.$fullscreenLoading();
        this.refreshClicked();
      }
    },
    // Clear Pop Up Entry for new
    clearPopUpEntry: function () {
      this.selectedRow = [];
      this.selectedEmailRow = [];
      this.selectedIdNo = '**/****/******';
      this.selectedSubject = '';
      this.selectedDuration = '';
      this.selectedAlertType = null;
      this.selectedDurationType = null;
      this.selectedPolicyType = null;
      this.selectedCategoryCode = null;
      this.selectedInventoryNo = null;
      this.selectedRemarks = '';
      this.selectedEmailRecipients = [];
      this.selectedEmailCc = [];
      this.selectedEmailBcc = [];
      this.selectedRecipients = [];
      this.selectedCc = [];
      this.selectedBcc = [];
      this.createdBy = '';
      this.updatedBy= '';
    },
    // Fill data for pop up entry for edit / view
    fillPopUpEntry: function () {
      // Get data from selected row
      this.createdBy = `${this.selectedRow[0]['UserCreated'] ? this.selectedRow[0]['UserCreated'].trim() : ''} ${this.selectedRow[0]['TimeCreated'] ? new Date(this.selectedRow[0]['TimeCreated']).formatString('dd/MM/yyyy HH:mm') : ''}`;
      this.updatedBy = `${this.selectedRow[0]['UserID'] ? this.selectedRow[0]['UserID'].trim() : ''} ${this.selectedRow[0]['DateUpdated'] ? new Date(this.selectedRow[0]['DateUpdated']).formatString('dd/MM/yyyy HH:mm') : ''}`;
      this.selectedIdNo = this.selectedRow[0]["ID"];
      this.selectedSubject = this.selectedRow[0]["Subject"];

      if (this.selectedRow[0]["Alert Type"] == "Expired")
        this.selectedAlertType = this.alertTypeData[1];
      else if (this.selectedRow[0]["Alert Type"] == "Before Due")
        this.selectedAlertType = this.alertTypeData[0];

      this.selectedDuration = this.selectedRow[0]["Duration"].toString();

      if (this.selectedRow[0]["Duration Type"] === "Week(s)")
        this.selectedDurationType = this.durationTypeData[0];
      else if (this.selectedRow[0]["Duration Type"] === "Day(s)")
        this.selectedDurationType = this.durationTypeData[1];
      else if (this.selectedRow[0]["Duration Type"] === "Hour(s)")
        this.selectedDurationType = this.durationTypeData[2]

      // // Get policy type 
      this.selectedPolicyType = this.policyTypeData.find((policy) => 
        policy["PolicyType"] === this.selectedRow[0]["Policy Type"]
      ) ?? { "PolicyType": this.selectedRow[0]["Policy Type"] ?? null };

      // Get category code
      this.selectedCategoryCode = this.categoryCodeData.find((category) => 
        category["Category Code"] === this.selectedRow[0]["Category Code"]
      ) ?? { "Category Code": this.selectedRow[0]["Category Code"] ?? null };

      // Get inventory number
      this.selectedInventoryNo = this.inventoryData.find((inventory) => 
        inventory["Lorry No"] === this.selectedRow[0]["Vehicle #"]
      ) ?? { "Lorry No": this.selectedRow[0]["Vehicle #"] ?? null };

      // Get remarks
      this.selectedRemarks = this.selectedRow[0]["Remarks"];
      this.selectedEmailRecipients = [];
      this.selectedEmailCc = [];
      this.selectedEmailBcc = [];
      this.selectedRecipients = [];
      this.selectedCc = [];
      this.selectedBcc = [];

      this.selectedEmailRecipients = this.selectedRow[0]["Recipient"].split(";").map(email => email.trim()).filter(email => email).map((email) => ({email}));
      this.selectedEmailCc = this.selectedRow[0]["Cc To"].split(";").map(email => email.trim()).filter(email => email).map((email) => ({email}));
      this.selectedEmailBcc = this.selectedRow[0]["Bcc To"].split(";").map(email => email.trim()).filter(email => email).map((email) => ({email}));

      let valueToMatch = this.selectedRow[0]["Recipient"].split(";");
      let items = this.emailListData;
      for (let i = 0; i < items.length; i++) {
        for(let j = 0; j < valueToMatch.length; j++){
          if (items[i]['Recipient'] === valueToMatch[j]) {
            this.selectedRecipients.push(items[i]);
          }
        }
      }

      valueToMatch = this.selectedRow[0]["Cc To"].split(";");
      for (let i = 0; i < items.length; i++) {
        for(let j = 0; j < valueToMatch.length; j++){
          if (items[i]['Recipient'] === valueToMatch[j]) {
            this.selectedCc.push(items[i]);
          }
        }
      }

      valueToMatch = this.selectedRow[0]["Bcc To"].split(";");
      for (let i = 0; i < items.length; i++) {
        for(let j = 0; j < valueToMatch.length; j++){
          if (items[i]['Recipient'] === valueToMatch[j]) {
            this.selectedBcc.push(items[i]);
          }
        }
      }
    },
    // Check if a row is selected for delete / edit / view 
    checkRowSelected: function () {
      if (this.selectedRow.length == 0)
        return true;
      else
        return false;
    },
    requiredClicked: async function(item) {
      this.$nextTick(() => {
        this.$refs[item].setFocus();
      });
    },
    // When an option is clicked from the left-side menu
    menuClicked: async function (option) {
      // Clear Error Messages
      this.clearErrorMessage();

      // Pop Up Options
      switch (option.title) {
        case 'New Policy Alert':
          // Get Action
          this.selectedAction = 'N';
          this.popupTitle = option.title;
          this.viewMode = false;

          // Clear Pop Up Entry 
          this.clearPopUpEntry();

          // Show New Pop Up Entry
          this.showPopup = true;

          break;

        case 'Edit Policy Alert':
          // Get Action
          this.selectedAction = 'E';
          this.popupTitle = option.title;
          this.viewMode = false;

          // Error message if no row selected
          if (this.checkRowSelected()) {
            await this.$showAlert('error', 'No Policy Alert Selected', `Please select a record to Edit Policy Alert`);
          }
          else {
            // Show Edit Pop Up Entry
            this.showPopup = true;

            // Fill Pop Up Entry 
            this.fillPopUpEntry();
          }
          break;
        case 'Delete Policy Alert':
          // Get Action
          this.selectedAction = 'D';

          // Error message if no row selected
          if (this.checkRowSelected()) {
            await this.$showAlert('error', 'No Policy Alert Selected', `Please select a record to Delete Policy Alert`);
          }
          else {
            // Fill Pop Up Entry 
            this.fillPopUpEntry();

            // Confirmation (Delete / Cancel)
            let deleteAction = await this.$showAlert('warning', 'Delete Policy Alert',
              `Are you sure you want to delete Policy Alert of ID: ${this.selectedIdNo}?`, [{
                text: 'Delete', textColor: 'white', color: 'red'
              },
              { text: 'Cancel', textColor: 'black', color: 'lightgray' },
            ]);

            // Delete button clicked
            if (deleteAction == 'Delete') {
              let result = await this.$apiCallV2(`/PolicyAlerts/SaveInventoryPolicyAlert`, {
                Action: this.selectedAction,
                Id: this.selectedIdNo
              });

              // Delete Successfully
              if (result[0]['Results'] == 0) {
                this.$showAlert('success', 'Policy Alert Deleted',
                  `Successfully deleted Policy Alert ${this.selectedIdNo}`);
                this.refreshClicked();
              }
              // Delete not succeed
              else {
                this.$showAlert('error', 'Policy Alert NOT Deleted',
                  `There was an error deleting Policy Alert ${this.selectedIdNo}`);
              }
            }
            // Cancel button clicked
            else {
              // Clear selected row
              this.clearPopUpEntry();
            }

          }
          break;
        case 'View Policy Alert':
          // Get Action
          this.selectedAction = 'V';
          this.popupTitle = option.title;
          this.viewMode = true;

          // Error message if no row selected
          if (this.checkRowSelected()) {
            await this.$showAlert('error', 'No Policy Alert Selected', `Please select a record to View Policy Alert`);
          }
          else {
            // Show Pop Up Entry
            this.showPopup = true;

            // Fill Pop Up Entry 
            this.fillPopUpEntry();
          }
          break;
      }

    },
    refreshClicked: async function () {
      // Latest refresh time
      this.lastRefreshed = (new Date()).formatString('yyyy-MM-dd HH:mm');

      // Get latest Policy Alert List
      this.loadData();
    },
    // Check filters to prevent duplicate emails
    checkFilter: function () {
      // Get all selected emails
      var selectedEmails = [];
      selectedEmails = this.selectedEmailRecipients.concat(this.selectedEmailCc, this.selectedEmailBcc);

      // check if current emails appear in selected (Yes = existed / No = not existed)
      var recipients = new Set();
      return selectedEmails.some((item) => {
        if (recipients.has(item.email.replace(/\s+/g, ''))) {
          return true;
        }
        else {
          recipients.add(item.email.replace(/\s+/g, ''));
          return false;
        }
      });
    },
    normalizePolicyAlertItem: function (item) {
      const source = item || {};
      const vehicleNo = source['Vehicle #'] ?? source['Inventory #'] ?? '';
      const normalized = {};
      let vehicleNoAdded = false;

      Object.keys(source).forEach((key) => {
        if (key == 'Inventory #' || key == 'Vehicle #') {
          if (!vehicleNoAdded) {
            normalized['Vehicle #'] = vehicleNo;
            vehicleNoAdded = true;
          }
        } else {
          normalized[key] = source[key];
        }
      });

      if (!vehicleNoAdded) normalized['Vehicle #'] = vehicleNo;
      return normalized;
    },
    loadListData: async function () {
      // Load GetListMaster data
      this.$fullscreenLoading('Getting Input Options');
      this.alertTypeData = await this.$apiCallV2('/PolicyAlerts/GetListMaster?master=ALERTTYPE');
      this.durationTypeData = await this.$apiCallV2('/PolicyAlerts/GetListMaster?master=DURATIONTYPE');
      this.categoryCodeData = await this.$apiCallV2('/PolicyAlerts/GetListMaster?master=VEHICLECATEGORY_UNIQUE');
      this.inventoryData = await this.$apiCallV2('/PolicyAlerts/GetListMaster?master=LORRYNO');
      this.policyTypeData = await this.$apiCallV2('/PolicyAlerts/GetListMaster?master=POLICYTYPE');
      this.emailListData = await this.$apiCallV2('/PolicyAlerts/GetEmailRecipientList');
      this.$fullscreenLoading();

      this.$fullscreenLoading('Getting Policy Alerts');
      this.policyAlertListData = (await this.$apiCallV2('/PolicyAlerts/GetInventoryPolicyAlertList')).map(
        this.normalizePolicyAlertItem,
      );
      this.policyAlertListData.forEach(policyAlert => {
        // Format Policy Type
        const policyType = this.policyTypeData.find(policyType => policyAlert["Policy Type"] == policyType["Type"]);
        if (policyType) {
          policyAlert["Policy Type"] = policyType["PolicyType"];
        }

        // Format Alert Type
        if (policyAlert["Alert Type"] == 0) {
          policyAlert["Alert Type"] = "Before Due";
        } else if (policyAlert["Alert Type"] == 1) {
          policyAlert["Alert Type"] = "Expired";
        }

        // Format Duration Type
        if (policyAlert["Duration Type"] == 'W') {
          policyAlert["Duration Type"] = "Week(s)";
        } else if (policyAlert["Duration Type"] == 'D') {
          policyAlert["Duration Type"] = "Day(s)";
        }
      });

      // Filter out combined emails
      this.emailListData = this.emailListData.filter(obj =>
        obj.Recipient && !obj.Recipient.includes(';')
      );
      this.$fullscreenLoading();
    },
    // Load Data
    loadData: async function () {
      this.policyAlertListData = [];
      // Load Inventory Policy Alerts
      this.$fullscreenLoading('Getting Policy Alerts');
      this.policyAlertListData = (await this.$apiCallV2('/PolicyAlerts/GetInventoryPolicyAlertList')).map(
        this.normalizePolicyAlertItem,
      );
      this.$fullscreenLoading();
    },
    emailRecipientListDataClicked: function() {
      const inputtedEmails = this.selectedEmailRecipients.map((email) => email.email);
      this.selectedEmailRow = this.emailListData.filter((recipient) => inputtedEmails.includes(recipient.Recipient));
      this.showRecipientEmailList = true;
    },
    emailCcListDataClicked: function() {
      const inputtedEmails = this.selectedEmailCc.map((email) => email.email);
      this.selectedEmailRow = this.emailListData.filter((recipient) => inputtedEmails.includes(recipient.Recipient));
      this.showCcEmailList = true;
    },
    emailBccListDataClicked: function() {
      const inputtedEmails = this.selectedEmailBcc.map((email) => email.email);
      this.selectedEmailRow = this.emailListData.filter((recipient) => inputtedEmails.includes(recipient.Recipient));
      this.showBccEmailList = true;
    },
    emailsPopupAddButtonClicked: function() {
      if (this.showRecipientEmailList) {
        const allEmailRecipients = this.emailListData.map((recipient) => recipient.Recipient);
        const manuallyInputtedEmails = this.selectedEmailRecipients.filter((email) => !allEmailRecipients.includes(email.email));
        this.selectedEmailRecipients = this.selectedEmailRow.map(email => ({ email: email.Recipient})).concat(manuallyInputtedEmails);

        this.selectedEmailRow = [];
        this.showRecipientEmailList = false;
      } else if (this.showCcEmailList) {
        const allEmailRecipients = this.emailListData.map((recipient) => recipient.Recipient);
        const manuallyInputtedEmails = this.selectedEmailCc.filter((email) => !allEmailRecipients.includes(email.email));
        this.selectedEmailCc = this.selectedEmailRow.map(email => ({ email: email.Recipient})).concat(manuallyInputtedEmails);

        this.selectedEmailRow = [];
        this.showCcEmailList = false;
      } else if (this.showBccEmailList) {
        const allEmailRecipients = this.emailListData.map((recipient) => recipient.Recipient);
        const manuallyInputtedEmails = this.selectedEmailBcc.filter((email) => !allEmailRecipients.includes(email.email));
        this.selectedEmailBcc = this.selectedEmailRow.map(email => ({ email: email.Recipient})).concat(manuallyInputtedEmails);

        this.selectedEmailRow = [];
        this.showBccEmailList = false;
      }
    },
    emailsPopupCancelButtonClicked: function() {
      if (this.showRecipientEmailList) { 
        this.selectedEmailRow = [];
        this.showRecipientEmailList = false;
      }
      else if (this.showCcEmailList) {
        this.selectedEmailRow = [];
        this.showCcEmailList = false;
      }
      else if (this.showBccEmailList) {
        this.selectedEmailRow = [];
        this.showBccEmailList = false;
      }
    }
  },
  async mounted() {
    // Get SAS Control Access
    this.$bus.$on('pageSASControlAccess', (SAS) => {
      if (SAS.page == 'Policy Alerts') {
        SAS.data.forEach(k => {
          if (k.Control === "cmdExtCredit" && k.Properties === "Visible") {
            this.SASShowExtCredit = k.PropertiesValue === "True";
            return;
          }

          //key in menu same as control value from api
          let selectedMenu = this.menus.find(m => m['key'] == k['Control']);
          if (selectedMenu) {
            selectedMenu[k['Properties'].toLowerCase()] = (k['PropertiesValue'] == 'True');
          }
        })
      }
    });
    this.showMenu = true;

    // Latest refresh time
    this.lastRefreshed = (new Date()).formatString('yyyy-MM-dd HH:mm');

    // Load data
    this.loadListData();
  },
  watch: {

  }

}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.policy-alert-main {
  font-size: 12px;
  width: 200px;
  height: 100%;
  padding: 10px 5px 10px 45px;
  display: flex;
  overflow: hidden;

  >.left-container {
    border-radius: 5px;
    width: fit-content;
    background-color: white;
    margin-right: 5px;
    height: 100%;
    transition: 0.3s;
  }

  >.right-container {
    border-radius: 5px;
    width: 100%;
    height: 100%;
    overflow: hidden;

    >.top-right-container {
      width: 100%;
      border-radius: 5px;
      height: 40px;
      background-color: white;
      margin-bottom: 5px;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      >.refresh-button {
        margin-right: 5px;
      }

      >.last-refreshed {
        margin-right: 5px;
      }
    }

    >.bottom-right-container {
      width: 100%;
      height: calc(100% - 40px);
      border-radius: 5px;
      background-color: white;
      display: flex;
      margin-right: 5px;
      padding: 5px;

      >.tablebox {
        height: calc(100% - 3px);
        background-color: white;
        display: flex;
        overflow: hidden;
        width: 100%;
      }
    }
  }
}

.popup-content {
  height: 100%;

  >.popup-content-top {
    display: flex;
    flex-direction: row;

    >.popup-content-top-left {
      margin-right: 10px;
      flex: 1;

      >.input-query {
        margin-bottom: 8px;
      }

      >.alert-dropdown {
        width: 50%;
        margin-bottom: 8px;
      }

      >.duration {
        display: flex;
        flex-direction: row;
        margin-bottom: 8px;

        >.duration-dropdown {
          width: 250px;

        }

        >.duration-input {
          width: 130px;
          padding-right: 10px;
        }

      }

      >.id-no {
        width: 50%;
        margin-bottom: 8px;
      }

      >.subject {
        width: 50%;
        margin-bottom: 8px;
      }
    }

    >.popup-content-top-right {
      flex: 1;

      >.filters {
        height: 53%;
      }
    }
  }
  .emails-popup-container {
    position: fixed;
    top: $top-nav-height;
    left: 0;
    height: calc(100% - #{$top-nav-height});
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100000;

    > .emails-popup {
      height: 80%;
      width: 50%;
      padding: 5px;
      border-radius: 5px;
      background-color: white;
      display: flex;
      flex-direction: column;

      > .emails-table-box {
        overflow:hidden;
      }

      > .call-to-action-buttons {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        padding-top: 5px;

        > button {
          margin: 0 3px 0 3px;
        }
      }
    }
  }
}
</style>
